<template>
    <div class="row">
        <input-select class="col-12" :label="tipoLabel" v-model="form[nomeColunaTipo]" :options="tipoOptions" ref="tipo" required/>
        <input-textarea class="col-12" label="Detalhamento" v-model="form.detalhamento" ref="detalhamento" required/>
        <input-textarea class="col-12" label="Justificativa" v-model="form.justificativa" ref="justificativa" required/>
        <input-money class="col-12 col-md-3" label="Valor R$" v-model="form.valorUnitario" ref="valor" required/>
        <input-text class="col-12 col-md-3" type="number" label="Quantidade" v-model="form.quantidade" ref="quantidade" required/>
        <input-text readonly class="col-12 col-md-3" label="Valor Total R$" v-model="valor" ref="valorTotal" required/>
        <input-select class="col-12 col-md-3" label="Mês da despesa" :options="mesesDepesas" v-model="form.mesDespesa" ref="mes" required/>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputText from "@/components/inputs/InputText";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputMoney from "@/components/inputs/InputMoney";

import {FormMixin} from "@/common/mixins/FormMixin";

import helpers from "@/common/utils/helpers";

export default {
    name: "VD",
    mixins: [FormMixin],
    props: {
        form : {
            type: Object,
            default: null
        },
        tipoLabel : {
            type: String,
            default: "Tipo de recurso"
        },
        tipoOptions : {
            default: []
        },
        duracao : {
            default: 0
        },
        nomeColunaTipo: {
            default: "tipo"
        },
    },
    components: {
        InputSelect,
        InputText,
        InputTextarea,
        InputMoney
    }, 
    data : () =>({
        options : {
            tipos: helpers.getPGViagemDiaria()
        }
    }),
    computed:{
        mesesDepesas(){
            return helpers.criarArrayMes(`2022-01-01`,this.duracao, true);
        },
        valor : {
            get : function(){
                return helpers.formatarValor((this.form.valorUnitario ? this.form.valorUnitario.replace('R$ ','').replace(/\./g, '').replace(',', '.') : 0) * this.form.quantidade);
            },
            set : function(value){
                this.form.valor = value;
            }
        }
    }
}
</script>
<style lang="">
    
</style>